module.exports = __webpack_public_path__ + "static/jason-long-avatar-290e0cb3203170bcbf2f7c4577a33b7b.jpeg";